export default "assets/images/logo-d09d9217.png";